<template>
  <div>
    <a-modal
    width="600px"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
      :closable="true"
    >
    <UserLogin ref="userlogin" @ok="loginok" @cancel="handleCancel"></UserLogin>
    </a-modal>
  </div>
</template>
<script>
import UserLogin from './moudles/UserLogin.vue'

export default {
    components: {
  UserLogin
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
      this.refreshCheckCodeLogin();
    },
    refreshCheckCodeLogin() {
      if(this.$refs.userlogin) {
        this.$refs.userlogin.refreshCheckCode();
      }
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds';
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);

    },
    handleCancel(e) {
      this.visible = false;

    },
    loginok(result){
      this.handleCancel()
      this.$emit('ok',result)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/login/Login.vue